"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusProductionOrderBatchColors = void 0;
const StatusProductionOrderBatchColors = exports.StatusProductionOrderBatchColors = {
  PAUSED: '#FFFF00',
  // yellow
  CREATED: '#808080',
  // grey
  PRODUCTION_AND_STARTED: '#008000',
  // green
  FINISHED_NOK: '#0000FF',
  // blue
  FINISHED_OK: '#FF0000',
  // red
  SHIPPED: '#A03A9F',
  // purple
  CANCELLED: '#FFA500',
  // orange
  PAUSED_LETTER_COLOR: '#000000',
  // black
  WHITE_COLOR: '#FFFFFF' // white
};